import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=1f5667f4&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=ts"
export * from "./ChatBox.vue?vue&type=script&lang=ts"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=1f5667f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5667f4",
  null
  
)

export default component.exports